import React, { useEffect, useState } from "react";
import { ProgressBar, OverlayTrigger, Tooltip } from "react-bootstrap";
import { chartThemeColorsDonut, chartThemeThresholds } from "./index";

const parseData = (data) => {
  if (data && (data.length || Object.keys(data)?.length))
    return {
      bar: data?.bar ? Object.values(data.bar) : Array.isArray(data) ? data : [],
    };
  return {
    bar: [],
  };
};

const getIndex = (value, type) => {
  if (type === "compliance") {
    if (value < 65) return 2;
    if (value < 85) return 1;
    return 0;
  }

  if (type === "variance") {
    if (value > 7) return 2;
    if (value > 3) return 1;
    return 0;
  }

  return 0;
};

const LineBarWidget = ({ data, isCart= true, heading, size }) => {
  const [formattedData, setFormattedData] = useState({
    bar: null,
  });

  useEffect(() => {
    if (data) {
      setFormattedData(parseData(data));
    } else {
      setFormattedData({
        bar: null,
      });
    }
  }, [data]);

  return (
    <div className={`col row mx-0 ${size} ${isCart ? "mt-3 px-2" : "mt-1"} position-relative`}>
      <div className="row px-0 mx-0 justify-content-between col col-12 mt-0">
        <div className={`${isCart ? "dashboard__card" : ""} col col-12 w-100 flex-basis-100`}>
          {heading && heading !== "ca" ? (
            <div className="d-flex align-items-center">
              <h5 className="mb-0 mt-0">{heading}</h5>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="cost-formula-tooltip">
                    <div className="text-left p-2" style={{ fontSize: "11px", lineHeight: "1.3" }}>
                      <p className="mb-1"><strong>1. Actual Cost %</strong></p>
                      <p className="mb-2"> Actual Cost % = (Actual Cost / Sales) × 100</p>
                      <p className="mb-1"><strong>2. Ideal Cost %</strong></p>
                      <p className="mb-0">Ideal Cost % = (Ideal Cost / Sales) × 100</p>
                      <p className="mb-1"><strong>3. Variance %</strong></p>
                      <p className="mb-0">Variance % = ((Actual Cost - Ideal Cost) / Ideal Cost) × 100</p>
                    </div>
                  </Tooltip>
                }
              >
                <i className="fa fa-eye ml-2 text-primary cursor-pointer" style={{ fontSize: "14px", cursor: "pointer" }}></i>
              </OverlayTrigger>
            </div>
          ) : ""}
          <div
            className="d-flex flex-col mx-3 my-2"
            style={{ gap: "1rem" }}
          ></div>
          {formattedData.bar ? (
            <div className="my-1 bill_modal_scroll rounded-sm border border-1" style={{borderColor:"#dddddd", maxHeight: isCart ? "250px" : "160px", overflowY: "auto", overflowX: "hidden", background:"white" }}>
              {formattedData.bar.map((item, index) => {
                  const value = parseFloat(item.value) || 0;
                  const barWidth = Math.min(Math.max(value, 0), 100);
                  let ind = 0;
                  let color;

                  if(heading === "ca"){
                    ind = index % chartThemeColorsDonut.length
                    color = chartThemeColorsDonut[ind]
                  }else{
                    const type = (heading === "Compliance By Branch") ? "compliance" : "variance";
                    ind = getIndex(value, type);
                    color = chartThemeThresholds[ind];
                  }
                  
                  const v1 = (item?.ideal_food_cost_percenatge && Number(item.ideal_food_cost_percenatge).toFixed(1)) || Number(item.value).toFixed(1);
                  const v2 = (item?.ideal_food_cost_percenatge && Number(item.ideal_food_cost_percenatge).toFixed(1)) || (item.value2 && Number(item.value2).toFixed(1));
                  return (
                    <div key={index} className="m-2 d-flex align-items-center">
                      <div className="flex-shrink-0 text-truncate font-weight-md" style={{ width: "100px", fontSize: "12px", }}>
                        {item.name}
                      </div>
                      <ProgressBar style={{ height: "12px", borderRadius: "5px", backgroundColor: "#eeeeee" }} className="flex-grow-1 mx-1">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={barWidth}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{
                            width: `${barWidth}%`,
                            backgroundColor: color,
                            borderRadius: "5px",
                            transition: "width 0.8s ease-out"
                          }}
                        />
                      </ProgressBar>
                      <div className="flex-shrink-0 text-right font-weight-md ml-1" style={{ maxWidth: "75px", width: "70px", fontSize: "12px" }}>
                        {v1}% {v2 ? <span style={{color: "#555555"}}>/ {v2}%</span> : ""}
                      </div>
                    </div>
                  );
                })
              }
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default LineBarWidget;
